import { render } from "./AwardsNew.vue?vue&type=template&id=2e96fc1a"
import script from "./AwardsNew.vue?vue&type=script&lang=js"
export * from "./AwardsNew.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__